<template>
    <div class="classify-process">
        <div class="header">
            <div class="text">分类流程</div>
            <div class="search">
                <el-input
                    v-model="keyword"
                    clearable
                    size="small"
                    prefix-icon="el-icon-search"
                    placeholder="流程名称"
                ></el-input>
            </div>
        </div>
        <div class="container">
            <div class="left-side">
                <div class="items">
                    <template v-for="(item, index) of classifyData">
                        <div
                            :key="index"
                            :class="[{ isActive: item.isActive }, 'item']"
                            @click="handleClassifyClick(item)"
                        >
                            {{ item.name }}
                        </div>
                    </template>
                </div>
            </div>
            <div class="right-side">
                <el-tree node-key="id" :data="treeData" :props="defaultProps" @node-click="handleNodeClick">
                    <template slot-scope="{ node, data }">
                        <div class="tree-current-title">
                            <i v-if="data.isProcess" class="title-prefix-icon process-icon"></i>
                            <i v-else class="title-prefix-icon file-icon"></i>
                            <span v-html="treeLabelFormat(data)"></span>
                        </div>
                    </template>
                </el-tree>
            </div>
        </div>
    </div>
</template>

<script>
//防抖
function debounce(fn, delay) {
    let timer = null;
    return function() {
        clearTimeout(timer);
        let args = arguments;
        let that = this;
        timer = setTimeout(function() {
            fn.apply(that, args);
        }, delay);
    };
}
import { getProcessTree } from "@/api";
export default {
    name: "ClassifyProcess",
    data() {
        return {
            keyword: "",
            treeData: [],
            classifyData: [],
            defaultProps: {
                children: "children",
                label: "name",
            },
        };
    },
    watch: {
        keyword: debounce(function() {
            this.loadProcessTree();
        }, 500),
    },
    mounted() {
        this.loadProcessTree();
    },
    activated() {
        this.processTreeDataConversion(this.classifyData);
    },
    methods: {
        // 加载分类
        loadProcessTree() {
            let params = {};
            this.treeData = [];
            // this.classifyData = [];
            if (this.keyword) {
                params.processName = this.keyword;
            }
            getProcessTree(params).then((res) => {
                if (res.status) {
                    this.processTreeDataConversion(res.body);
                }
            });
        },

        processTreeDataConversion(data) {
            if (data.length === 0) {
                return;
            }
            let { newArray, defaultExpandNode } = this.getDefaultExpandNode(data);
            this.classifyData = JSON.parse(JSON.stringify(newArray));
            // 设置默认展开的节点
            if (defaultExpandNode) {
                this.handleClassifyClick(defaultExpandNode);
            } else {
                this.treeData = [];
            }
        },
        // 默认展开的节点
        getDefaultExpandNode(data) {
            let newArray = [];
            let defaultExpandNode = null;
            data.forEach((ele) => {
                let obj = {
                    id: ele.id,
                    url: ele.url,
                    isActive: false,
                    name: ele.name,
                    ifNbpm: ele.ifNbpm,
                    children: ele.children,
                };
                newArray.push(obj);
                if (!defaultExpandNode && ele.children.length > 0) {
                    defaultExpandNode = ele;
                }
            });
            return { newArray, defaultExpandNode };
        },
        handleSearch() {
            this.loadProcessTree();
        },
        // 流程分类点击事件
        handleClassifyClick(item) {
            this.classifyId = item.id;
            this.classifyData.forEach((ele) => {
                ele.isActive = false;
                if (ele.id === item.id) {
                    ele.isActive = true;
                    this.treeData = JSON.parse(JSON.stringify(ele.children));
                }
            });
            if (item.children.length > 0) {
                return;
            }
            let params = { id: item.id, isProcess: false };
            this.$emit("loadProcessUrlById", params, item);
        },
        // tree节点点击事件
        handleNodeClick(node) {
            // 不是流程数据，或者 当前节点有子级
            if (node.children.length > 0) {
                return;
            }
            let params = { id: node.id, isProcess: node.isProcess };
            this.$emit("loadProcessUrlById", params, node);
        },
        // tree 高亮匹配
        treeLabelFormat(data) {
            if (data.name.includes('<span style="color:#3A9D80">')) {
                data.name = data.name.replace('<span style="color:#3A9D80">', "");
                data.name = data.name.replace("</span>", "");
            }
            if (!this.keyword) {
                return data.name;
            }
            if (data.name.includes(this.keyword)) {
                return data.name.replace(this.keyword, `<span style="color:#3A9D80">${this.keyword}</span>`);
            }
        },
    },
};
</script>

<style scoped lang="scss">
.classify-process {
    padding: 0 20px;
    padding-bottom: 20px;
    font-family: PingFangSC-Medium, PingFang SC;
    height: 100%;
    .header {
        padding: 20px 0 10px 0;
        position: relative;
        .text {
            font-size: 16px;
            font-weight: 500;
            line-height: 22px;
            color: #666666;
        }
        .search {
            right: 0;
            top: 15px;
            position: absolute;
        }
    }
    .container {
        display: flex;
        height: calc(100% - 52px);
        .left-side {
            width: 180px;
            border: 1px solid #e1e2e3;
            .items {
                height: 100%;
                overflow: auto;
                padding: 12px;
                .item {
                    font-size: 14px;
                    color: #333;
                    height: 32px;
                    line-height: 32px;
                    padding: 0 12px;
                    cursor: pointer;
                }
                .item:hover {
                    background-color: #f5f7fa;
                }
                .isActive {
                    color: #fff;
                    border-radius: 4px;
                    background: #54aa91;
                }
                .isActive:hover {
                    color: #fff;
                    border-radius: 4px;
                    background: #54aa91;
                }
            }
        }
        .right-side {
            flex: 1;
            height: 100%;
            overflow: auto;
            border: 1px solid #e1e2e3;
            border-left: unset;
            background-color: #f9f9f9;
        }
    }
}
</style>

<style lang="scss">
.classify-process {
    .right-side {
        .el-tree {
            background-color: #f9f9f9;
            .tree-current-title {
                .title-prefix-icon {
                    width: 16px;
                    height: 14px;
                    margin-right: 8px;
                    display: inline-block;
                    background-size: 100%;
                    background-position: bottom;
                    background-repeat: no-repeat;
                }
                .process-icon {
                    background-image: url(../../../../../common/images/process-icon.png);
                }
                .file-icon {
                    background-image: url(../../../../../common/images/file-icon.png);
                }
            }
            .el-tree-node__content {
                color: #000;
                height: 35px !important;
                border-bottom: 1px solid #e1e2e3;
            }
            .is-current {
                > .el-tree-node__content {
                    color: #fff !important;
                    background-color: #25a589 !important;
                    > .tree-current-title {
                        color: #fff !important;
                        .process-icon {
                            background-image: url(../../../../../common/images/process-icon2.png);
                        }
                    }
                }
            }
        }
    }
}
</style>
